import { getTracksOfTheWeek } from "../../services/dataProvider";

export const INIT_TRACKS_OF_THE_WEEK = "INIT_TRACKS_OF_THE_WEEK";
export const TRACKS_OF_WEEK_CHANGE_PAGE = "TRACKS_OF_WEEK_CHANGE_PAGE";
export const TRACKS_OF_WEEK_SET_FAVORITE = "TRACKS_OF_WEEK_SET_FAVORITE";
export const TRACKS_OF_WEEK_DROP_FAVORITE = "TRACKS_OF_WEEK_DROP_FAVORITE";
export function setFavoriteTrack(songId, page) {
  return { type: TRACKS_OF_WEEK_SET_FAVORITE, payload: { songId, page } };
}
export function dropFavoriteTrack(songId, page) {
  return { type: TRACKS_OF_WEEK_DROP_FAVORITE, payload: { songId, page } };
}
export function initTracksOfTheWeek() {
  return (dispatch) => {
    getTracksOfTheWeek().then((result) => {
      dispatch({ type: INIT_TRACKS_OF_THE_WEEK, payload: result });
    });
  };
}
export function trackPagination(pageData, page) {
  return {
    type: TRACKS_OF_WEEK_CHANGE_PAGE,
    payload: { pageData, page },
  };
}
